import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { Link } from '@inertiajs/react'
import Button from '../../components/Button'

export default function ActivitiesIndex({ activities }) {
  return (
    <AuthenticatedLayout>
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900">Aktiviteter</h1>
          <Link href="/activities/new">
            <Button>Ny aktivitet</Button>
          </Link>
        </div>

        <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
          {activities.length === 0 && (
            <p className="px-4 py-12 text-center text-gray-500 text-sm">
              Inga aktiviteter ännu.
            </p>
          )}
          {activities.map(a => (
            <Link
              key={a.id}
              href={`/activities/${a.id}`}
              className="flex items-center justify-between px-4 py-4 hover:bg-gray-50"
            >
              <div>
                <p className="font-medium text-gray-900">{a.name}</p>
                {a.description && (
                  <p className="text-sm text-gray-500 mt-0.5 line-clamp-1">{a.description}</p>
                )}
              </div>
              <div className="text-right text-sm text-gray-500">
                <p>{a.products_count} produkter</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
